import { Helmet } from "react-helmet";
import Loader from "../../Components/Loader";
import { useEffect, useRef, useState } from "react";
import { Accordion, Dropdown } from "react-bootstrap";
import { DonorService } from "../../Services/Donor.Service";
import TokenService from "../../Services/Token.service";
import Toaster from "../../Components/Toaster";

const GetPaid = () => {

    //dropdown state for address.
    const states = [
        "Alabama", "Alaska", "Arizona", "Arkansas", "California",
        "Colorado", "Connecticut", "Delaware", "Florida", "Georgia",
        "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas",
        "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts",
        "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana",
        "Nebraska", "Nevada", "New Hampshire", "New Jersey",
        "New Mexico", "New York", "North Carolina", "North Dakota",
        "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
        "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah",
        "Vermont", "Virginia", "Washington", "West Virginia",
        "Wisconsin", "Wyoming", "Maharashtra",
    ];

    
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [loading, setLoading] = useState(false);

    const [paymentType, setPaymentType] = useState(""); // online | cheque
    const [method, setMethod] = useState(""); // paypal | venmo

    const [setPaymentStatusFields, showSetPaymentStatusFields] = useState(false);

    const [paymentUserName, setPaymentUserName] = useState(""); //online

    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [postalCode, setPostalCode] = useState("");


    const [paymentTypeData, setPaymentTypeData] = useState(null);

    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
        fetchPaymentMethod();
    }, []);

    const fetchPaymentMethod = async () => {
        setLoading(true);
        try {
            const payload = { user_id: TokenService.getUserId() }
            const result = await DonorService.getPaymentMethod(payload); 
            if (result.status && result.payment_data && (result.payment_data.online != null || result.payment_data.cheque != null)) {

                setPaymentTypeData(result.payment_data);

                if (result.payment_data.cheque?.payment_method_status === "1") {
                    setPaymentType("cheque");
                }
                else if (result.payment_data.online?.payment_method_status === "1") {
                    setPaymentType("online");
                }
                else {
                    setPaymentType("");
                }

                if (result.payment_data && result.payment_data.cheque) {
                    setAddress1(result.payment_data.cheque.address_line_1);
                    setAddress2(result.payment_data.cheque.address_line_2);
                    setCity(result.payment_data.cheque.city);
                    setState(result.payment_data.cheque.state);
                    setPostalCode(result.payment_data.cheque.postal_code);
                }
                if (result.payment_data && result.payment_data.online) {
                    setPaymentUserName(result.payment_data.online.payment_username);
                    // setMethod(result.payment_data.online.payment_method_name);

                     const methodName = result.payment_data.online.payment_method_name?.toLowerCase();
                    // Explicit mapping for better readability
                    const displayMethod =
                        methodName === "paypal"
                            ? "PayPal"
                            : methodName === "venmo"
                            ? "Venmo"
                            : methodName;

                    setMethod(displayMethod);
                }
                // setPaymentType(result.payment_data);
            }
            else {
                setPaymentType(null);
                setMethod("");
            }
            setLoading(false);
        }
        catch {
            setLoading(false);

        }
    };

    const handlePaymentTypeChange = (type) => {
        console.log(type);
        setPaymentType(type);

        clearValidationError('paymentType',)
    }

    const selectOnlinePaymentMethod = async () => {
        setPaymentType("online");

        showSetPaymentStatusFields(true);
    }

    const setOnlinePaymentMethod = (onlinePaymentType) => {
        setMethod(onlinePaymentType);
        clearValidationError("method",onlinePaymentType);
    }

    const handleSave = async (type) => {//OnlinePaymentSave
        if (!validateForm(type)) return;
        try {

            console.log(type); // online or check 
            setLoading(true);
            let payload;

            if (type === 'online') {
                payload = {
                    user_id: TokenService.getUserId(),
                    payment_type: paymentType,
                    payment_method: method.toLowerCase(),
                    payment_username: paymentUserName
                };
            }
            else {
                payload = {
                    user_id: TokenService.getUserId(),
                    payment_type: paymentType,
                    address_1: address1,
                    address_2: address2,
                    city: city,
                    state: state,
                    postal_code: postalCode

                }
            }
            const result = await DonorService.savePaymentMethod(payload);
            let toastMsg = '';

            if (result.status) {
            toastMsg = result.message;
            } else {
            // If backend returns a dictionary of field errors
            if (typeof result.message === 'object' && result.message !== null) {
                // Flatten nested error arrays into a readable string
                toastMsg = Object.entries(result.message)
                .map(([key, val]) => `${val.join(', ')}`)
                .join(' | ');
            } else {
                toastMsg = result.message || 'An error occurred';
            }
            }

            setShowToast(true);
            setToastMessage(toastMsg);
            setToastVariant(result.status ? 'success' : 'error');

            setLoading(false);
        }
        catch (error) {
            setShowToast(true);
            setToastMessage(error.message || 'Error updating payment method');
            setToastVariant('error');
            setLoading(false);
        }
    }


    const handleAddressStateChange = (state) => {
        setState(state);
        clearValidationError('state', state)
    }

    const validateForm = (type) => {
        const errors = {};

        // Common validation for payment type selection
        if (!paymentType) {
            errors.paymentType = "Please select a payment type (Online or Cheque).";
        }
        
        if (type === "online") {
            if (!method) errors.method = "Please select a payment method (PayPal or Venmo).";
            if (!paymentUserName.trim()) errors.paymentUserName = "Please enter your payment username.";
        }

        if (type === "cheque") {
            if (!address1.trim()) errors.address1 = "Street address is required.";
            if (!city.trim()) errors.city = "City is required.";
            if (!state.trim()) errors.state = "State is required.";
            if (!postalCode.trim()) errors.postalCode = "Postal/Zip code is required.";
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0; // returns true if no errors
    };
    const clearValidationError = (field, value) => {
        if(value!==''){
            setValidationErrors((prev) => {
                const updated = { ...prev };
                delete updated[field];
                return updated;
            });
        }
    };

    const dropdownMenuRef = useRef(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
    const handleKeyDown = (e) => {
      if (!show || !dropdownMenuRef.current) return;

      const key = e.key.toLowerCase();
      if (key.length === 1 && key.match(/[a-z]/i)) {
        const target = states.find((s) => s.toLowerCase().startsWith(key));
        if (target) {
          const item = Array.from(dropdownMenuRef.current.children).find(
            (el) => el.textContent.trim() === target
          );
          if (item) {
            item.scrollIntoView({ behavior: "smooth", block: "nearest" });
          }
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [show]);

    return (
        <>
            <Loader loading={loading} />
            <Helmet>
                <title>DonorX | Get Paid</title>
            </Helmet>

            <div className="el-middle-wrapper">
                <h2 className="el-title">GET PAID</h2>
                <label>Decide how you'll receive payment for successfully completed donations below.</label>
                <div className="">
                    <>  
                        {validationErrors.paymentType && (
                            <p className="text-danger mb-2">{validationErrors.paymentType}</p>
                        )}
                        <div className="el-bg-table el-super-admin mt-3 w-75">
                            <Accordion activeKey={"1"}>
                                <Accordion.Item eventKey="1">
                                    <div className="p-3 border-bottom">
                                        <div className="d-flex align-items-center">
                                            <input
                                                type="radio"
                                                id="online"
                                                name="paymentType"
                                                checked={paymentType === "online"}
                                                onChange={() => handlePaymentTypeChange("online")}
                                                className="me-2 form-check-input"
                                            />
                                            <label htmlFor="online" className="mb-0 fw-semibold">
                                                Pay me by PayPal or Venmo.
                                            </label>
                                        </div>

                                        <div className="mt-3">
                                            <h3 className="get-paid-card-title">GET PAID IN 48 HOURS</h3>
                                            <p  className="get-paid-card-text mt-3"> 
                                                Donor X uses PayPal or Venmo to pay you securely. Once you select your
                                                payment method and enter your username, you'll receive a small deposit
                                                and you must confirm the amount prior to payment method being activated.
                                            </p>
                                        </div>
                                        <hr />

                                        {paymentTypeData?.online != null && (
                                            <div>
                                                <div className="d-flex">
                                                    <p className="get-paid-card-text mb-0">
                                                       Payment Method: {
                                                            paymentTypeData?.online?.payment_method_name?.toLowerCase() === "paypal"
                                                                ? "PayPal"
                                                                : paymentTypeData?.online?.payment_method_name?.toLowerCase() === "venmo"
                                                                ? "Venmo"
                                                                : paymentTypeData?.online?.payment_method_name
                                                        }
                                                    </p>
                                                    <button
                                                        type="button"
                                                        className="back-link ms-2"
                                                        onClick={() => selectOnlinePaymentMethod()}
                                                    >
                                                        <span>(UPDATE)</span>
                                                    </button>
                                                </div>
                                                <p className="get-paid-card-text mt-1 mb-0">
                                                    Username: {paymentTypeData?.online.payment_username}
                                                </p>
                                            </div>
                                        )}

                                        {/* <p className="mt-2">
                                            Status:{" "}
                                            {paymentTypeData?.online != null ? (
                                                <label className="text-danger">Pending</label>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="back-link ms-2"
                                                    onClick={() => selectOnlinePaymentMethod()}
                                                >
                                                    SELECT PAYMENT METHOD
                                                </button>
                                            )}
                                        </p> */}
                                        <p className="mt-2">
                                            Status:{" "}

                                            {paymentTypeData?.online ? (
                                                paymentTypeData.online.account_status === "1" ? (
                                                    <label className="text-success">Confirmed</label>
                                                ) : (
                                                    <label className="text-danger">Pending</label>
                                                )
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="back-link ms-2"
                                                    onClick={() => selectOnlinePaymentMethod()}
                                                >
                                                    SELECT PAYMENT METHOD
                                                </button>
                                            )}
                                        </p>

                                        {validationErrors.method && <p className="text-danger mt-1">{validationErrors.method}</p>}

                                        {setPaymentStatusFields === true && (
                                            <>
                                            <div className="row">
                                                <div className="col-6">
                                                    <Dropdown onSelect={(eventKey, e) => setOnlinePaymentMethod(e.target.textContent)}>
                                                        <Dropdown.Toggle className="form-control dropdown-method">
                                                            {method !== "" ? method : "PayPal/Venmo"}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item eventKey="paypal">PayPal</Dropdown.Item>
                                                            <Dropdown.Item eventKey="venmo">Venmo</Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                                <div className="col-6">
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        value={paymentUserName}
                                                        onChange={(e) => {setPaymentUserName(e.target.value); clearValidationError('paymentUserName',e.target.value )} }
                                                        placeholder="Enter Username"
                                                        maxLength={"20"}

                                                    />
                                                    {validationErrors.paymentUserName && (
                                                    <p className="text-danger mt-1">{validationErrors.paymentUserName}</p>
                                                    )}  
                                                </div>
                                            </div>

                                                <div className="d-flex mt-3">
                                                    <button
                                                        className="el-main-button me-3"
                                                        onClick={() => {  
                                                            handleSave("online")
                                                        }}
                                                    >
                                                        <span>Save</span>
                                                    </button>
                                                    <button
                                                        onClick={() => showSetPaymentStatusFields(false)}
                                                        className="el-main-button me-3"
                                                    >
                                                        <span>Cancel</span>
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </Accordion.Item>
                            </Accordion>
                            <Accordion className="mt-5" activeKey={"2"}>
                                <Accordion.Item className="" eventKey="2">
                                    <div className="p-3">
                                        <div className="d-flex align-items-center">
                                            <input
                                                id="check"
                                                name="paymentType"
                                                type="radio"
                                                checked={paymentType === "cheque"}
                                                onChange={() => handlePaymentTypeChange("cheque")}
                                                className="me-2 form-check-input"
                                            />
                                            <label htmlFor="check" className="mb-0 fw-semibold">
                                                Mail me a physical check.
                                            </label>
                                        </div>

                                        <div className="mt-3">
                                            <h3><b>CHECK BY MAIL, 7-10 BUSINESS DAYS</b></h3>
                                            <p className="get-paid-card-text mt-3">
                                                Will take up to 7–10 business days with a $15 processing fee. Where
                                                should we mail your check?
                                            </p>

                                            <div className="mt-3">
                                                <input
                                                    type="text"
                                                    value={address1}
                                                    onChange={(e) => {setAddress1(e.target.value); clearValidationError('address1',e.target.value)}}
                                                    className="form-control"
                                                    placeholder="Street Address"
                                                    maxLength={"50"}
                                                />
                                                {validationErrors.address1 && <p className="text-danger">{validationErrors.address1}</p>}
                                            </div>
                                            <div className="mt-3">
                                                <input
                                                    type="text"
                                                    value={address2}
                                                    onChange={(e) => setAddress2(e.target.value)}
                                                    className="form-control"
                                                    placeholder="Apt/Suite"
                                                    maxLength={"50"}

                                                />
                                            </div>
                                            <div className="mt-3">
                                                <input
                                                    type="text"
                                                    value={city}
                                                    onChange={(e) => {setCity(e.target.value); clearValidationError('city',e.target.value)}}
                                                    className="form-control"
                                                    placeholder="City"
                                                    maxLength={"20"}

                                                />
                                                {validationErrors.city && <p className="text-danger">{validationErrors.city}</p>}

                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-6">
                                                    <Dropdown show={show}    onToggle={(isOpen) => setShow(isOpen)} value={state} onSelect={handleAddressStateChange}>
                                                        <Dropdown.Toggle className="form-control dropdown-method">
                                                            {state ? state : "Please choose state"}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu ref={dropdownMenuRef} className="drodpown-states">
                                                            {states.map((s) => (
                                                                <Dropdown.Item eventKey={s} key={s}>
                                                                    {s}
                                                                </Dropdown.Item>
                                                            ))}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                {validationErrors.state && <p className="text-danger">{validationErrors.state}</p>}

                                                </div>
                                                <div className="col-6">
                                                    <input
                                                        type="text"
                                                        value={postalCode}
                                                        onChange={(e) => {setPostalCode(e.target.value); clearValidationError('postalCode', e.target.value)}}
                                                        className="form-control"
                                                        placeholder="Zip code"
                                                        maxLength={"5"}
                                                        />
                                                    {validationErrors.postalCode && <p className="text-danger">{validationErrors.postalCode}</p>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mt-3">
                                            <button
                                                type="button"
                                                className="el-main-button me-3"
                                                onClick={() => { setPaymentType("cheque"); handleSave("cheque")}}
                                            >
                                                <span>SAVE ADDRESS</span>
                                            </button>
                                        </div>
                                    </div>
                                </Accordion.Item>
                            </Accordion>
                        </div>

                        <div className="d-flex align-items-center mt-4">
                            <button type="button" onClick={()=> handleSave(paymentType)} className="el-main-button me-3"><span>SAVE PAYMENT PREFERENCES</span></button>
                        </div>
                    </>
                </div>
            </div>
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </>
    );
}
export default GetPaid;